exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2iUMdY{display:flex;flex-wrap:wrap;list-style:none;padding:0;margin:0}._MzY6c{justify-content:flex-start}._SPd4R{justify-content:center}._1H7ntZ{justify-content:flex-end}._13kU4I{align-items:flex-start}._1A3OE5{align-items:center}._LhCR5{align-items:flex-end}._11Q4tC{padding:0}._7V7hx{flex:1}._j0GFy{display:flex}._2181U{align-self:flex-start}._4n7J85{align-self:flex-end}._WrnAz{align-self:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/react-flexr.css
 ** module id = 780
 ** module chunks = 0
 **/